const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: "",
          afterFix: "년",
          labelHiddenResolution: "xl",
          useAll: true,
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { y_m: "month" },
        options: {
          default: "",
          lastLabel: true,
          useAll: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "최근 안전검사일", "자기 안전검사일", "설치일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도 (장비는 누계로 관리하므로 연도 "전체"가 기본값, 연도를 선택한 경우에만 작성일로 필터)
    if (search.year) {
      let year = Number(search.year);
      let month = search.month;
      const startDate = new Date(`${year}-${month || "01"}-01`).format("yyyy-MM-dd");
      const endDate = month ? new Date(new Date(startDate).setMonth(new Date(startDate).getMonth() + 1)).format("yyyy-MM-dd") : `${year + 1}-01-01`;
      conditions.push({ key: "created_at", operator: ">=", value: startDate });
      conditions.push({ key: "created_at", operator: "<", value: endDate });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 3) {
          return func.comma(func.getContent(value).subInfo.구간길이);
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.subInfo.구분",
      },
      {
        name: "설치위치",
        key: "body.subInfo.설치위치",
      },
      {
        name: "구간길이(M)",
        key: "body.subInfo.구간길이",
      },
      {
        name: "자체 관리번호",
        key: "body.subInfo.자체관리번호",
      },
      {
        name: "설치일",
        key: "body.subInfo.설치일",
      },
      {
        name: "합격번호",
        key: "body.subInfo.합격번호",
      },
      {
        name: "최근 안전검사일",
        key: "body.subInfo.최근안전검사일",
        style: { minWidth: "120px" },
      },
      {
        name: "차기 안전검사일",
        key: "body.subInfo.차기안전검사일",
        style: { minWidth: "120px" },
      },
      {
        name: "제작업체",
        key: "body.subInfo.제작업체",
      },
    ];
  },
};

export default list;
